import axios from 'axios';
import { useEffect, useState } from 'react';
import {Modal} from 'react-bootstrap';
import Select from "react-select";

const AddNewNotification = ({show, setShow, formData, action, setFormData, setNotification, setReRender}) => {
    const [loader, setLoader] = useState(false);
    const [users, setUsers] = useState([]);

    useEffect(() => {
        axios(`/api/extension/v1/users?page=1&limit=1000&keyword=&sort_by=id&sort_order=DESC&eligible_to_bid=&blocked=&admin_id=&active=`)
            .then((res) => {
                const data = res.data.data.map((u) => ({label: u.username, value: u.username}));
                setUsers(data);
            })
            .catch((err) => {
                setLoader(false);
                setNotification({show: true, type: "error", text: err.response.data.message.en});
                setTimeout(() => {
                    setNotification({show: false, title: "", text: ""});
                }, 3000);
            })
    }, [])

    const handlers = {
        addNewNotification(e){
            e.preventDefault();
            setLoader(true);
            const usersList = formData.users.map((p) => p.value);
            const form = {...formData, users: usersList};
            axios.post('/api/extension/v1/notifications', form)
                .then((res) => {
                    setNotification({show: true, type: "success", text: res.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                    setShow((prev) => ({...prev, createNotification: false}));
                    setReRender((prev) => prev + 1)
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                })
        },
        editNotification(e){
            e.preventDefault();
            setLoader(true);
            const usersList = formData.users.map((p) => p.value);
            const form = {...formData, users: usersList};
            axios.put(`/api/extension/v1/notifications/${formData.id}`, form)
                .then((res) => {
                    setNotification({show: true, type: "success", text: res.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                    setShow((prev) => ({...prev, createNotification: false}));
                    setReRender((prev) => prev + 1)
                })
                .catch((err) => {
                    setNotification({show: true, type: "error", text: err.response.data.message.en});
                    setTimeout(() => {
                        setNotification({show: false, title: "", text: ""});
                    }, 3000);
                    setLoader(false);
                })
        }
    }

    return(
        <Modal show={show} onHide={() => setShow((prev) => ({...prev, createNotification: false}))} size='lg' centered>
            <Modal.Header closeButton><h2 className="modal-title-text">Add New Notification</h2></Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <form className='row' onSubmit={handlers[action == "add" ? "addNewNotification" : "editNotification"]}>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-buyer">Title*</label>
                                <input id="form-buyer" required placeholder="Enter notification title" type="text" className="form-control" name="buyer" value={formData.title} onChange={(e) => setFormData((prev) => ({...prev, title: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-auction">Notification type*</label>
                                <select id="form-auction" required className="form-control" name="auction" value={formData.alert_type} onChange={(e) => setFormData((prev) => ({...prev, alert_type: e.target.value}))}>
                                    <option value={""}>Select Notification Type</option>
                                    <option value={"#28a745"}>Success</option>
                                    <option value={"#17a2b8"}>Info</option>
                                    <option value={"#ffc107"}>Warning</option>
                                    <option value={"#dc3545"}>Problem</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-md-12 mb-4'>
                            <Select
                                isMulti
                                className={"no-padding"}
                                options={users}
                                value={formData.users}
                                onChange={(e) => {
                                    setFormData((prev) => ({ ...prev, users: [...e] }))
                                }}
                            />
                        </div>
                        <div className="col-md-12 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-password">Message*</label>
                                <textarea style={{height: "100px"}} id="form-password" required placeholder="Enter message" type="text" className="form-control" name="password" value={formData.html} onChange={(e) => setFormData((prev) => ({...prev, html: e.target.value}))}/>
                            </div>
                        </div>
                        <div className="modal-action-buttons">
                            <button type="submit" disabled={loader} className="submit-modal-form-btn">{loader ? <div className="button-loader"></div> : (action == "add" ? "Submit" : "Save")}</button>
                            <button type="button" onClick={() => setShow((prev) => ({...prev, createNotification: false}))} className="cancel-modal-form-btn">Cancel</button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewNotification